import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { constantApp } from "../../../../config/constant";
import { myDate } from "../../../../Function/dateTime";

class News extends Component {
  constructor() {
    super();

    this.state = {
      Title: "",
      Content: "",
      DateSabt: "",
      data: [],
    };
  }

  componentDidMount = async () => {
    let url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/News/ListNews.php`;
    let param = {
      isLIMIT: true,
    };

    let data = await axios
      .post(url, param)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        // this.setState({ isNetworkError: true })
        // console.log('error :::', error)
      });

    // alert(JSON.stringify(url));

    if (data !== undefined && data.length > 0) {
      this.setState({ data });
    }
  };

  render() {
    return (
      <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-4">
              <div className="section-title">
                <h2>خبرها</h2>
              </div>
            </div>
            <div className="col col-lg-6 col-md-5">
              <p>
                تغییر، مهم‌ترین مؤلفه جهان امروز است. بهبود عملکرد در سایه آگاهی
                از اخبار و تغییرات میسر خواهد شد.
              </p>
            </div>
            <div className="col col-lg-3 col-md-3">
              <div className="all-news-link">
                <Link to="news" className="theme-btn">
                  خبر بیشتر
                </Link>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col col-xs-12">
              <div className="news-grids">
                {this.state.data.map((item) => {
                  return (
                    <div className="grid" key={item.idNews}>
                      <div className="entry-media">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            `assets/images/news/img-${item.idNews}.jpg`
                          }
                          alt=""
                          role="presentation"
                        />
                      </div>
                      <div className="entry-details">
                        <div className="entry-meta">
                          <ul>
                            <li>
                              <span className="fa fa-clock-o"></span>{" "}
                              {myDate(item.DateSabt)}
                            </li>
                          </ul>
                        </div>
                        <div className="entry-body">
                          <h3>
                            <Link
                              to={{
                                pathname: `news/${item.idNews}`,
                                state: { id: item.idNews },
                              }}
                            >
                              {" "}
                              {item.Title.length < 55
                                ? `${item.Title}`
                                : `${item.Title.substring(0, 55)}...`}
                            </Link>
                          </h3>
                          <p> {`${item.Brief.substring(0, 40)}...`}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default News;
